import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { InvestmentDetailsTextField } from '../atomic-components/InvestmentDetailsTextField';
import { InvestmentDetailsAdditionTextField } from '../atomic-components/InvestmentDetailsAdditionTextField';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';

interface Props {
  disabled: boolean;
}

export const InvestmentInformation: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.investmentinformation.title')}>
      <InvestmentDetailsTextField disabled={disabled} />
      <AssetTypeConditional supported={['builderOwnerModel']}>
        <InvestmentDetailsAdditionTextField />
      </AssetTypeConditional>
    </LaunchpadCard>
  );
};
